import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=830d1868"
import script from "./OptionGroup.vue?vue&type=script&lang=js"
export * from "./OptionGroup.vue?vue&type=script&lang=js"
import style0 from "./OptionGroup.vue?vue&type=style&index=0&id=830d1868&prod&lang=css"
import style1 from "../../../assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports